// This site uses CRA, not Astro. Share the production origin between build and browser.
export const SITE_URL = "https://ateno.co";
export const DEFAULT_IMAGE = "/og.jpg";
export const DEFAULT_DESCRIPTION = "Ateno AX is a coprocessor for 3DGS reconstruction and training. FPGA prototype.";

export function resolveSeoImage(image = DEFAULT_IMAGE) {
  try {
    const url = new URL(image, SITE_URL);
    // Only opaque JPEG assets are eligible for social previews.
    if (url.protocol === "https:" && /\.jpe?g$/i.test(url.pathname)) return url.href;
  } catch { /* Invalid inputs use the branded card. */ }
  return new URL(DEFAULT_IMAGE, SITE_URL).href;
}

export function resolveSeo({ title, description = DEFAULT_DESCRIPTION, image = DEFAULT_IMAGE,
  path = "/", canonical, type = "website", titleSuffix = true } = {}) {
  return {
    title: title ? `${title}${titleSuffix ? " | Ateno" : ""}` : "Ateno",
    description,
    image: resolveSeoImage(image),
    canonical: new URL(canonical || path, SITE_URL).href,
    type,
  };
}
